import Vue from 'vue';
import Vuex, {createLogger} from 'vuex';
import modules from './modules';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';
const state = {
  token: localStorage.getItem('token') || '',
  user: undefined
};
const store = new Vuex.Store({
  modules,
  actions: {
    reset({commit}) {
      // resets state of all the modules
      Object.keys(modules).forEach(moduleName => {
        commit(`${moduleName}/RESET`);
      });
    }
  },
  state,
  getters: {
    user() {
      return state.user;
    },
    customer() {
      return state.customer;
    },
    token(state) {
      return state.token;
    },
    accessCheck(state) {
      // eslint-disable-next-line prettier/prettier
      return access => state.user && state.user.roles.indexOf(access) > -1;
    }
  },
  mutations: {
    AUTH_SUCCESS(state, {token, user}) {
      state.token = token;
      state.user = user;
      localStorage.setItem('token', token);
    },
    USER_CUSTOMER(state, {user}) {
      state.user = user;
    },
    logout(state) {
      state.token = '';
      state.user = {};
      localStorage.removeItem('token');
    }
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [] // set logger only for development
});

export default store;
